import { ArrowUpRight } from "lucide-react";
import { CONTACT } from "@/data/content";
import { Logo } from "./Nav";
import { MaskedLines, Reveal } from "./Reveal";

export const ContactFooter = () => (
  <section id="contact" className="section section-dark contact" data-testid="contact-section">
    <span className="contact-watermark" aria-hidden="true">AP</span>

    <Reveal>
      <p className="mono-label lime">Let's build reliability together</p>
    </Reveal>
    <MaskedLines as="h2" className="section-title on-dark" lines={["Need parts that"]} data-testid="contact-title" />
    <MaskedLines as="h2" className="section-title on-dark serif-italic" delay={0.12} lines={["won't let you down?"]} />
    <Reveal delay={0.2}>
      <p className="contact-sub" data-testid="contact-subtitle">
        Speak with AP Enterprises about excavator spare parts, OEM-grade pins and
        bushes, or genuine JIC hydraulic components in India.
      </p>
      <a href={`mailto:${CONTACT.emails[0]}`} className="btn btn-light" data-testid="contact-email-btn">
        Email AP Enterprises <ArrowUpRight size={16} />
      </a>
    </Reveal>

    <Reveal delay={0.1} className="contact-grid">
      <div data-testid="contact-phones">
        <p className="mono-label">Call us</p>
        {CONTACT.phones.map((p) => (
          <a key={p} href={`tel:${p.replace(/\s/g, "")}`} className="contact-line" data-testid={`phone-${p.replace(/[+\s]/g, "")}`}>
            {p}
          </a>
        ))}
      </div>
      <div data-testid="contact-emails">
        <p className="mono-label">Write to us</p>
        {CONTACT.emails.map((e) => (
          <a key={e} href={`mailto:${e}`} className="contact-line" data-testid={`email-${e.split("@")[0]}`}>
            {e}
          </a>
        ))}
      </div>
      <div data-testid="contact-address">
        <p className="mono-label">Principal business address</p>
        <p className="contact-line">{CONTACT.address}</p>
      </div>
    </Reveal>

      <div className="footer-bar" data-testid="footer-bar">
        <Logo />
      <p>© {new Date().getFullYear()} AP Enterprises. All rights reserved.</p>
      <a href="#top" className="link-underline small" data-testid="back-to-top">
        Back to top ↑
      </a>
    </div>
  </section>
);
